import * as api from '@/api'

export default {
  async getOneBySlug(payload) {
    let result = {}

    try {
      result = await api.topics.getOneBySlug(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  }
}
